import { useMutation } from '@tanstack/react-query';
import {
  PersonalizationCategoryChannelUpdateData,
  PersonalizationEventChannelUpdateData,
} from '@/api/apis/communication/personalization/personalization.types';
import { api } from '@/api';
import { retryDelay, shouldRetryOnError } from '@/queries/case';
import { queryClient } from '@/queries';
import { personalizationQueryKeys } from '@/queries/communication/personalization/personalization.query.keys';
import {
  updatePersonalizationEventChannelMutation,
  updatePersonalizationCategoryChannel,
} from '@/queries/communication/personalization/utils';

export const useUpdatePersonalizationCategoryChannelMutation = () => {
  return useMutation({
    mutationFn: async ({ categoryName, channelType, data }: PersonalizationCategoryChannelUpdateData) =>
      api.personalization.updatePersonalizationCategoryChannel(categoryName, channelType, data),
    retry: shouldRetryOnError,
    retryDelay,
    onSuccess: (_, variables) => {
      queryClient.setQueriesData(
        { queryKey: personalizationQueryKeys.getList() },
        updatePersonalizationCategoryChannel(variables),
      );
    },
  });
};

export const useUpdatePersonalizationEventChannelMutation = () => {
  return useMutation({
    mutationFn: ({ eventName, channelType, data }: PersonalizationEventChannelUpdateData) =>
      api.personalization.updatePersonalizationEventChannel(eventName, channelType, data),
    retry: shouldRetryOnError,
    retryDelay,
    onSuccess: (_, variables) => {
      queryClient.setQueriesData(
        { queryKey: personalizationQueryKeys.getList() },
        updatePersonalizationEventChannelMutation(variables),
      );
    },
  });
};
